export default __webpack_public_path__ + "static/media/prenda3.affaa4d3.jpg";